import ReactDOM from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import "./index.css"
import "./styles/non-tailwind.css"
import "./styles/paper.css"
import "react-toastify/dist/ReactToastify.css"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import { ConfigProvider as AntdThemeConfigProvider, theme } from "antd"
import { UsercommProviderBLE } from "./usercomm/local/ble/usercommProviderBLE"
import { COLOR_BG_BLUE, COLOR_BG_DARK_BLUE, COLOR_BG_LIGHT_BLUE } from "./utils/utils"
import { ToastContainer } from "react-toastify"
import React from "react"
import { toastNotifyUpdateIsInstalled } from "./utils/toast"
import { TranslationProvider } from "./providers/translationProvider"
import { CloudUsercommProviderWS } from "./usercomm/cloud/cloudUsercommProviderWS"
import { SyncronizationProvider } from "./providers/syncronizationProvider"
import { APIProvider as GoogleMapsApiProvider } from "@vis.gl/react-google-maps"

// Flags emoji polyfill for Chrome/Windows
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill"
import { AppLayout } from "./AppLayout"
import { ErrorBoundary } from "react-error-boundary"
polyfillCountryFlagEmojis()

const SubProvider = React.memo(() => (
  <GoogleMapsApiProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY!}>
    <AntdThemeConfigProvider
      componentSize="large"
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          sizeStep: 5,
          sizeUnit: 2,
          fontSize: 14,
          colorBgBase: "#fff",
          colorBgContainer: "#fff",
          colorBgLayout: "#fff",
          colorPrimary: COLOR_BG_BLUE,
          colorLink: COLOR_BG_BLUE,
          fontFamily: "Tahoma, sans-serif",
          borderRadius: 8,
        },
        components: {
          Layout: {
            siderBg: COLOR_BG_BLUE,
            triggerBg: COLOR_BG_LIGHT_BLUE,
            headerBg: "#fff",
            headerHeight: 74,
          },
          Menu: {
            darkItemColor: "#fff",
            darkItemBg: COLOR_BG_BLUE,
            darkItemSelectedBg: COLOR_BG_LIGHT_BLUE,
            darkItemHoverBg: COLOR_BG_LIGHT_BLUE,
            darkSubMenuItemBg: COLOR_BG_DARK_BLUE,
            darkPopupBg: COLOR_BG_DARK_BLUE,
          },
          Tree: {
            nodeSelectedBg: COLOR_BG_LIGHT_BLUE,
          },
        },
      }}
    >
      <ToastContainer
        style={{
          marginTop: "4rem",
        }}
      />
      <AppLayout />
    </AntdThemeConfigProvider>
  </GoogleMapsApiProvider>
))

ReactDOM.render(
  <ErrorBoundary
    fallbackRender={({ error, resetErrorBoundary }) => {
      let stackLines: string[] = error.stack?.split("\n") || []
      stackLines = stackLines.filter((line) => !line.includes("__webpack_modules__"))
      return (
        <div style={{ padding: "1rem" }}>
          <h2 style={{ color: "red" }}>Uncaught exception: {error.message}</h2>
          <pre>{stackLines.join("\n")}</pre>
          <div style={{ height: "10px" }} />
          <div style={{ marginTop: "10px" }}>
            Please report to customer support if the issue persists. URL:{" "}
            <b>{window.location.href}</b>
          </div>
          <div style={{ marginTop: "10px" }}>
            <a href="/">GO TO HOME PAGE</a>
          </div>
        </div>
      )
    }}
  >
    <Router>
      <CloudUsercommProviderWS>
        <UsercommProviderBLE>
          <SyncronizationProvider>
            <TranslationProvider>
              <SubProvider />
            </TranslationProvider>
          </SyncronizationProvider>
        </UsercommProviderBLE>
      </CloudUsercommProviderWS>
    </Router>
  </ErrorBoundary>,
  document.getElementById("root"),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log(`Index: serviceWorkerRegistration: onUpdate: `, registration)
    if (registration.waiting) {
      console.log(`Index: serviceWorkerRegistration: sending SKIP_WAITING`)
      registration.waiting.postMessage({
        type: "SKIP_WAITING",
      })
    }
    toastNotifyUpdateIsInstalled()
  },
})
